import {Vue} from 'ui.vue';

import "./BXmakerAuthuserphoneRefresh.styl";

/**
 * @emits onClick {}
 */
Vue.component('BXmakerAuthuserphoneRefresh', {
    template: `
        <div class="bxmaker-authuserphone-refresh"  @click.prevent.stop="$emit('onClick')">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" >
                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"
                      d="M22.143 23.365C20.221 25.008 17.726 26 15 26 8.925 26 4 21.075 4 15M7.857 6.635C9.779 4.992 12.274 4 15 4c6.075 0 11 4.925 11 11"/>
                <path d="M26 20L22 14 30 14zM4 10L8 16 0 16z"/>
            </svg>
        </div>
        `,
});